/**
 * @file devices.ts
 * @description Устройства для «Показывать: Телефон · Планшет · ПК»
 * (phase19.16 Р2; uiux-design-r2 §2, §4): у секции хранится «показывать»,
 * у элемента — «скрыть» (`hide`); здесь перевод и сводка словами.
 */

export interface DeviceFlags {
  phone: boolean;
  tablet: boolean;
  desktop: boolean;
}

export const DEVICES: ReadonlyArray<{ key: keyof DeviceFlags; label: string }> = [
  { key: "phone", label: "Телефон" },
  { key: "tablet", label: "Планшет" },
  { key: "desktop", label: "ПК" },
];

/** «Скрыть» элемента → «показывать» для поля. */
export function showFromHide(hide: DeviceFlags | undefined): DeviceFlags {
  return { phone: !(hide?.phone ?? false), tablet: !(hide?.tablet ?? false), desktop: !(hide?.desktop ?? false) };
}

/** «Показывать» → «скрыть» элемента; виден везде — ключа нет. */
export function hideFromShow(show: DeviceFlags): DeviceFlags | undefined {
  return show.phone && show.tablet && show.desktop ? undefined : { phone: !show.phone, tablet: !show.tablet, desktop: !show.desktop };
}

/** Сводка: «везде», «кроме телефона», «только ПК». */
export function devicesSummary(show: DeviceFlags): string {
  const on = DEVICES.filter((d) => show[d.key]);
  if (on.length === 3) return "везде";
  if (on.length === 0) return "нигде";
  if (on.length === 1) return `только ${on[0]?.label.toLowerCase() ?? ""}`;
  const off = DEVICES.find((d) => !show[d.key]);
  return `кроме: ${off?.label.toLowerCase() ?? ""}`;
}
